var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5004 0.25C21.2405 0.25 26.848 5.0997 28.0236 11.5C26.848 17.9002 21.2405 22.75 14.5004 22.75C7.76015 22.75 2.15269 17.9002 0.977051 11.5C2.15269 5.0997 7.76015 0.25 14.5004 0.25ZM14.5004 20.25C19.7949 20.25 24.3254 16.565 25.4721 11.5C24.3254 6.43504 19.7949 2.75 14.5004 2.75C9.20575 2.75 4.67528 6.43504 3.52848 11.5C4.67528 16.565 9.20575 20.25 14.5004 20.25ZM14.5004 17.125C11.3937 17.125 8.87532 14.6066 8.87532 11.5C8.87532 8.3934 11.3937 5.875 14.5004 5.875C17.6069 5.875 20.1254 8.3934 20.1254 11.5C20.1254 14.6066 17.6069 17.125 14.5004 17.125ZM14.5004 14.625C16.2263 14.625 17.6254 13.2259 17.6254 11.5C17.6254 9.77413 16.2263 8.375 14.5004 8.375C12.7745 8.375 11.3753 9.77413 11.3753 11.5C11.3753 13.2259 12.7745 14.625 14.5004 14.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.d8e796f692f424ff85377001e57f9817.svg";
export { ForwardRef as ReactComponent };